<template>
  <suspense>
    <div>
      <lazy-fn-flexible-content
        v-if="type === 'flexible_content'"
        :page="page"
        :data="data"
      />
      <lazy-fn-goldener-fressnapf
        v-else-if="type === 'goldener_fressnapf'"
        :page="page"
        :data="data"
      />
      <lazy-fn-pet-salon
        v-else-if="type === 'pet_salon'"
        :page="page"
        :data="data"
      />
      <lazy-fn-pet-salon-career
        v-else-if="type === 'pet_salon_career'"
        :page="page"
        :data="data"
      />
      <lazy-fn-pet-salon-flexible
        v-else-if="type === 'pet_salon_flexible'"
        :page="page"
        :data="data"
      />
      <lazy-fn-pet-funeral
        v-else-if="type === 'pet_funeral'"
        :page="page"
        :data="data"
      />
      <lazy-fn-pet-funeral-booking
        v-else-if="type === 'pet_funeral_booking'"
        :page="page"
        :data="data"
      />
      <lazy-fn-wishpet-advisory
        v-else-if="type === 'wishpet_advisory'"
        :page="page"
        :data="data"
      />
      <lazy-fn-cms-default
        v-else
        :page="page"
        :data="data"
      />
    </div>
  </suspense>
</template>

<script setup lang="ts">
const props = defineProps<{
  type: string;
  data: Record<string, any>;
  page: Record<string, any>;
}>();
</script>
